export enum FieldAddressArrayActionTypes {
  SET_ADDRESSES,
  SET_PREVIOUS_ADDRESSES
}
